// Vendor Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {get, isEmpty, lowerCase, orderBy, startCase} from 'lodash';

// Components
import Input from '../core/input';
import SearchRecordDetails from '../app/search-record-details';
import TableWithSort from '../core/table-with-sort';

// Containers
import FlaggedMetadata from '../../containers/flagged-metadata';
import FormData from '../../containers/form-data';
import withPermissions from '../../containers/with-permissions';
import withSearch from '../../containers/with-search';

const servicesDataKey = 'flaggedMetadataDetail';
const formName = 'flaggedMetadataComments';

function FlaggedMetadataDetail(props) {
    const {hasAccessByRole, searchData} = props;

    const getColumnConfig = (flaggedMetadataSaveComments) => [
        {
            dataKey: 'fieldName',
            formatter: ({fieldName}) => startCase(fieldName),
            title: 'Field',
            width: '20%',
        },
        {
            dataKey: 'issueType',
            formatter: ({issueType}) => startCase(lowerCase(issueType)),
            title: 'Type',
            width: '15%',
        },
        {
            dataKey: 'comment',
            title: 'Comments',
            type: hasAccessByRole({allowRoles: ['flaggedMetadata_update']}) ? 'component' : 'string',
            component: Input,
            componentProps: (searchData) => getInputProps(searchData, flaggedMetadataSaveComments),
            width: '65%',
        },
    ];

    const getInputProps = ({issueId = ''} = {}, flaggedMetadataSaveComments) => ({
        className: 'flagged-metadata-detail--comment',
        onBlur: (event) => handleInputBlur(event, issueId, flaggedMetadataSaveComments),
        name: issueId.toString(),
    });

    const handleInputBlur = (_event, issueId, flaggedMetadataSaveComments) => {
        flaggedMetadataSaveComments(issueId);
    };

    const getResponseData = () => {
        const issues = get(searchData, '0.issues');

        return orderBy(issues, ['fieldName', 'issueType'], ['asc', 'asc']);
    };

    const getSearchRecordDetailProps = () => ({
        ...props,
        keyOrder: 'flaggedMetadata',
        blacklistKeys: ['issues', 'version'],
    });

    const renderResult = (flaggedMetadataSaveComments) => {
        const responseData = getResponseData();

        return !isEmpty(responseData) ? (
            <TableWithSort
                className="flagged-metadata-detail--table-with-sort"
                columnConfig={getColumnConfig(flaggedMetadataSaveComments)}
                localSort={true}
                notSortable={['comment']}
                searchData={responseData}
            />
        ) : null;
    };

    return (
        <FormData formName={formName}>
            {() => (
                <FlaggedMetadata>
                    {({flaggedMetadataSaveComments}) => (
                        <div className="flagged-metadata-detail">
                            <SearchRecordDetails {...getSearchRecordDetailProps()} />
                            {renderResult(flaggedMetadataSaveComments)}
                        </div>
                    )}
                </FlaggedMetadata>
            )}
        </FormData>
    );
}

FlaggedMetadataDetail.propTypes = {
    hasAccessByRole: PropTypes.func.isRequired,
    searchData: PropTypes.array,
};

export default withPermissions(withSearch(FlaggedMetadataDetail, servicesDataKey));
